import React from 'react';
import MediaQuery from 'react-responsive';
import AppsIcon from '@mui/icons-material/Apps';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import {Change} from '../compare/Change';
import {Color} from '../compare/Color';
import {currencyConverter} from '../../utility/methods';
import {useTranslation} from 'react-i18next';
import {getVehicleDetails} from "./photos.utils";
import {setIsAngleChanged} from "../../slices/vehicleSlice";
import {useDispatch} from "react-redux";

const PrimaryVehicleDetails = ({
                                   getCompareImages,
                                   showChangeSelector,
                                   changeHandler,
                                   isLocked,
                                   vehicleData,
                                   setVehicleData,
                                   openModal,
                                   handleModalClose,
                                   secondaryYear,
                                   vehiclesMakes,
                                   vehicleModel,
                                   trimModel,
                                   setTrimModel,
                                   setVehicleModel,
                                   setVehicleMake,
                                   vehiclesTrim,
                                   vehicleIndex,
                                   vehicleTypeName,
                                   driveType,
                                   setDriveType,
                                   viewAngle,
                                   setIsButtonClicked,
                                   filterArrayView,
                                   trackExteriorFilterButton,
                                   trackInteriorFilterButton,
                                   compareGroup,
                                   handleOpen,
                                   enlargeView,
                                   activeLocale,
                                   setOpenModal,
                                   headerLoadType

                               }) => {
    const {t} = useTranslation();
    const dispatch = useDispatch() ;
    const vehicleCTA = "https://www.jdpower.com/cars-for-sale/make-"+ getCompareImages[0]?.make.toLowerCase() + "/model-" + getCompareImages[0]?.model.toLowerCase().replace(/ /g, "-")
    return (
        <MediaQuery minWidth="320px" maxWidth="899px">
            <div className="vehicle-details">
                <div className="vehicle-description">
                    {getVehicleDetails(getCompareImages[0], 0)}
                    <div className="msrp-price">
                        <span>{t('overview.startingFrom')} </span>
                        <span>{currencyConverter(getCompareImages[0]?.pricing.msrp, activeLocale)}</span>
                    </div>
                </div>

                <React.Fragment>
                    <MediaQuery minWidth="320px" maxWidth="719px">
                        {showChangeSelector()}
                    </MediaQuery>
                </React.Fragment>

                <div className="photo-change-section">
                    {headerLoadType != null && (
                        <div className={"vehicle-CTA primary-mobile-CTA"}>
                            <a target="_blank" href={vehicleCTA}>See Cars For Sale</a>
                        </div>
                    )}
                    <div className="photo-change" >
                        <button
                            id="0"
                            className="btn-default btn-change-compare"
                            value={getCompareImages[0]}
                            onClick={(event) => changeHandler(0, getCompareImages[0])}
                            disabled={isLocked && isLocked[0]}
                        >
                            {t('overview.changeSelectModal.change')}
                        </button>

                        <Change
                            vehicleData={vehicleData}
                            setVehicleData={setVehicleData}
                            openModal={openModal}
                            setOpenModal={setOpenModal}
                            handleModalClose={handleModalClose}
                            years={secondaryYear}
                            vehicleMake={vehiclesMakes}
                            vehicleModels={vehicleModel}
                            trimModel={trimModel}
                            setTrimModel={setTrimModel}
                            setVehicleModel={setVehicleModel}
                            setVehicleMake={setVehicleMake}
                            vehiclesTrim={vehiclesTrim}
                            vehicleIndex={vehicleIndex}
                            vehicleTypeName={vehicleTypeName}
                            driveType={driveType}
                            setDriveType={setDriveType}
                            lockedVehicle={isLocked}
                        />

                        <Color
                            primaryColor={getCompareImages[0]?.colors?.exteriors}
                            translate={t}
                            id={0}
                            mediaColor={getCompareImages[0]?.currentColor}
                            interiorColor={getCompareImages[0]?.colors?.interiors}
                        />

                    </div>
                    <div className="photo-filter">
                        <button
                            className={viewAngle === "EXTERIOR" ? 'btn-active' : 'btn-default'}
                            onClick={() => {
                                setIsButtonClicked(true);
                                dispatch(setIsAngleChanged(true));
                                filterArrayView('Exterior');
                                trackExteriorFilterButton(compareGroup);
                            }}
                            id="filter-exterior"
                        >
                            {t('photo.filter.exterior')}
                        </button>

                        <button
                            className={viewAngle === "INTERIOR" ? 'btn-active' : 'btn-default'}
                            onClick={() => {
                                filterArrayView('Interior');
                                setIsButtonClicked(true);
                                dispatch(setIsAngleChanged(true));
                                trackInteriorFilterButton(compareGroup);
                            }}
                            id="filter-interior"
                        >
                            {t('photo.filter.interior')}
                        </button>

                        <button
                            className="btn-default"
                            id="view-photo-gallery"
                            onClick={() => handleOpen()}
                        >
                            <AppsIcon fontSize="small"/>
                        </button>

                        <button
                            className="btn-default enlarge-btn"
                            onClick={() => enlargeView()}
                            id="photos-enlarge-button"
                        >
                            <OpenInFullIcon fontSize="small"/> <span>Enlarge</span>
                        </button>
                    </div>
                </div>
            </div>
        </MediaQuery>
    );
};

export default PrimaryVehicleDetails;
